<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'

defineProps<PreparedAuctionItem['notice']>()
</script>

<template>
  <CommonLink
    :href="url"
    :title="label"
    class="mt-2 text-red after:bg-red"
    target="_blank"
    underline
    @click.stop
  >
    {{ label }}
  </CommonLink>
</template>
